module.exports = __webpack_public_path__ + "img/mycroptech-60x60.fffde526.png";